/**
 * The tenant's "Show Customer View to Shop Owners and Admins" setting (Admin → Branding), read the same way by
 * everything that enforces it (components/OwnerConsoleRedirect.jsx, components/RoleSwitcher.jsx).
 *
 * Stored as ``tenant.branding.staff_customer_view_enabled``. Missing means ON — every tenant's behaviour before the
 * setting existed — so only an explicit ``false`` hides anything. Customers and other roles are never affected.
 */

// The roles the setting governs, in the order used when one person holds both: the admin console first.
export const STAFF_CONSOLES = [
    ["TENANT_ADMIN", "/admin"],
    ["RESTAURANT_OWNER", "/merchant"],
];

export const STAFF_ROLES = new Set(STAFF_CONSOLES.map(([role]) => role));

export function consoleForRole(role) {
    const hit = STAFF_CONSOLES.find(([r]) => r === role);
    return hit ? hit[1] : null;
}

export function staffCustomerViewAllowed(tenant) {
    return tenant?.branding?.staff_customer_view_enabled !== false;
}
